import { render, staticRenderFns } from "./ergonomicsAtTheWorkplace.vue?vue&type=template&id=0549673a"
import script from "./ergonomicsAtTheWorkplace.vue?vue&type=script&lang=js"
export * from "./ergonomicsAtTheWorkplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports